import CtaSection from '@/components/CtaSection'
import Layout from '@/components/Layout'
import Seo from '@/components/Seo'
import { blogPosts, breadcrumbSchema, whatsappMessages } from '@/lib/site-data'
import {ArrowRight, Calendar, Clock} from 'lucide-react'
import { Link } from 'react-router-dom'

const crumbs = breadcrumbSchema([
  { name: 'Início', path: '/' },
  { name: 'Blog', path: '/blog' },
])

function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' })
}

function Blog() {
  return (
    <Layout>
      <Seo
        title="Blog | Guias sobre Comprar Página do Instagram | Muita Mídia"
        description="Artigos sobre onde comprar página do Instagram com segurança, sinais de alerta, como funciona a transferência e primeiros passos após a compra."
        path="/blog"
        jsonLd={crumbs}
      />

      <section className="relative overflow-hidden bg-[#0B0919]">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(139,92,246,0.18),transparent_60%)]" />
        <div className="relative mx-auto max-w-4xl px-6 py-16 text-center sm:py-24">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-xs font-medium text-[#C4B5FD]">
            Blog Muita Mídia
          </span>
          <h1 className="mt-6 text-3xl font-bold leading-tight text-white sm:text-4xl">
            Guias práticos para comprar uma página do Instagram com segurança
          </h1>
          <p className="mt-5 text-base leading-relaxed text-zinc-400 sm:text-lg">
            Conteúdo criado pela equipe da Muita Mídia para ajudar você a tomar a melhor decisão antes,
            durante e depois da compra da sua página.
          </p>
        </div>
      </section>

      <section className="bg-white">
        <div className="mx-auto max-w-5xl px-6 py-16 sm:py-20">
          <div className="grid gap-6 sm:grid-cols-2">
            {blogPosts.map(post => (
              <Link
                key={post.slug}
                to={`/blog/${post.slug}`}
                className="group flex flex-col rounded-2xl border border-zinc-100 bg-zinc-50 p-6 transition-colors hover:border-[#8B5CF6]/40 hover:bg-white"
              >
                <div className="flex items-center gap-4 text-xs text-zinc-500">
                  <span className="inline-flex items-center gap-1">
                    <Calendar className="h-3.5 w-3.5" />
                    {formatDate(post.publishedAt)}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <Clock className="h-3.5 w-3.5" />
                    {post.readTime}
                  </span>
                </div>
                <h2 className="mt-4 text-lg font-semibold text-zinc-900 group-hover:text-[#7C3AED]">
                  {post.title}
                </h2>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-zinc-600">{post.excerpt}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#7C3AED]">
                  Ler artigo
                  <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <CtaSection
        title="Já leu o suficiente e quer decidir agora?"
        description="Fale direto com a nossa equipe pelo WhatsApp e receba orientação personalizada."
        message={whatsappMessages.blogCta}
        tone="dark"
      />
    </Layout>
  )
}

export default Blog
